import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import { authGuard } from "@/auth/authGuard";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "launch",
		component: () => import("@/views/Launch.vue")
	},
	{
		path: "/home",
		name: "home",
		meta: { title: "Home", requiresAuth: true },
		beforeEnter: authGuard,
		component: () => import("@/views/Home.vue")
	},
	{
		path: "/employees",
		name: "edit-employees",
		meta: { title: "Employees", requiresAuth: true },
		beforeEnter: authGuard,
		component: () => import("@/views/EditEmployees.vue")
	},
	{
		path: "/profile",
		name: "edit-profile",
		props: true,
		meta: { title: "Profile", requiresAuth: true },
		beforeEnter: authGuard,
		component: () => import("@/views/EditProfile.vue")
	},
	{ path: "*", redirect: "/" }
	// { path: "*", component: () => import("../views/404.vue") }
];

const router = new VueRouter({
	mode: "history",
	routes
});

router.beforeEach((to, from, next) => {
	// Add Document Title
	document.title = (to.meta.title ? to.meta.title + " - " : "") + "Thermo";
	next();
});

// Old LocalStorage-Based Auth Guard
// router.beforeEach((to, from, next) => {
// 	const loggedIn = localStorage.getItem("savedUserData");
// 	if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
// 		// Auth required for this route, and user DOES NOT have auth
// 		next("/");
// 	}
// 	// Auth NOT required for this route OR Auth required for this route, and user has auth
// 	next();
// });

export default router;
